<template>
  <div class="clp-error">
    <div class="clp-error__close-btn button--minimal" v-if="this.parent === 'inline_alert'"
         @click="this.$emit('closeAlert')"
    >
      &#215;
    </div>
    <div class="clp-error__section clp-error__section--top">
      <div class="clp-error__title" v-if="this.type === 'server_fail'">
        Что-то пошло не так
      </div>
      <div class="clp-error__title" v-if="this.type === 'gosuslugi_fail' && this.parent !== 'inline_alert'">
        Ошибка подтверждения данных
      </div>
    </div>
    <div class="clp-error__section clp-error__section--middle">
      <div class="clp-error__subtitle" v-if="this.type === 'server_fail'">
        Попробуйте обновить страницу.
        Если проблема сохраняется,
        <nobr>просим обратиться</nobr>
        по телефону горячей линии
        <nobr><b>8 800 333 90 13</b></nobr>
      </div>
      <div class="clp-error__subtitle" v-if="this.type === 'gosuslugi_fail'">
        <b>Введенные данные не прошли проверку на портале «Госуслуги»</b><br>
        Проверьте все поля и подтвердите данные снова<br><br>
      </div>
<!--      <div class="clp-error__subtitle" v-if="this.type === 'gosuslugi_fail' && this.parent !== 'inline_alert'">-->
<!--        Или Вы можете заполнить короткую форму обратной связи, и мы перезвоним Вам лично для заключения договора-->
<!--      </div>-->
    </div>

    <div class="clp-error__section clp-error__section--bottom" v-if="this.parent !== 'inline_alert'">
      <button
          v-if="this.type === 'server_fail'" @click="this.$emit('closeDialog')"
          class="clp-error__button button" :class="{'button--sravni-smaller': this.page === 'sravni'}"
      >
        Назад
      </button>
      <button
          v-if="this.type === 'gosuslugi_fail'" @click="this.$emit('closeDialog')"
          class="clp-error__button button" :class="{'button--sravni-smaller': this.page === 'sravni'}"
      >
        Проверить поля
      </button>
<!--      <a v-if="this.type === 'gosuslugi_fail'" href="https://makclife.ru/sravniru/">-->
<!--        <button-->
<!--            class="clp-error__button button button&#45;&#45;unfilled button&#45;&#45;outline-grey"-->
<!--            :class="{'button&#45;&#45;sravni-smaller': this.page === 'sravni'}"-->
<!--        >-->
<!--          Оставить заявку-->
<!--        </button>-->
<!--      </a>-->
    </div>
  </div>
</template>

<script>
export default {
  props: ['descr', 'page', 'type', 'parent'],
  data() {
    return {};
  },
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
